var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.offset)?_c('button',{staticClass:"btn",on:{"click":function($event){$event.preventDefault();return _vm.handlePrevButtonClick($event)}}},[_vm._v("Prev ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }